import React, { Component } from 'react';
import withRouter from '../../lib/router/withRouter';
import PageTemplate from '../../components/template/PageTemplate';
import BrandDetailContainer from '../../containers/brand/BrandDetailContainer';
import { BRAND_PAGE_NAME } from '../../constants/service/app/brandConstants';

class BrandDetail extends Component {
  render() {
    const { match } = this.props;

    return (
      <PageTemplate pageName={BRAND_PAGE_NAME.BRAND_DETAIL}>
        <BrandDetailContainer storeId={match.params.id} />
      </PageTemplate>
    );
  }
}

export default withRouter(BrandDetail);
